import { Button as AntButton, Modal } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { updateParentPassword } from '../../../../api/students.api';
import useAxios from '../../../../hooks/useAxios';
import useNotification from '../../../../hooks/useNotification';
import ErrorResponse from '../../../ErrorResponse';
import Loader from '../../../Loader';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  parentCode: string | undefined;
}

const ResetParentPasswordModal: FC<IProps> = ({
  visible,
  setVisible,
  parentCode,
}) => {
  const { t } = useTranslation();
  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('auth.findPassword.message5'));
      onClose();
    }
  }, [res, isLoading]);

  const onClose = () => {
    setPassword('');
    setConfirmPassword('');
    setVisible(false);
  };

  const onSubmit = () => {
    if (!parentCode) return;

    const regex = /.{6,12}/;
    if (!regex.test(password))
    return infoNotification(t('student.student.message8'));
    if (password !== confirmPassword)
      return infoNotification(t('student.student.message9'));

    execute(updateParentPassword({ parentCode, webPass: password }));
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('학부모 비밀번호 변경')}
        visible={visible}
        onCancel={onClose}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton key="submit" className='btn-basic pink' type="primary" onClick={onSubmit}>
              {t('common.button.save')}
            </AntButton>
            <AntButton key="cancel" className='btn-basic gray' onClick={onClose}>
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="form-group row">
          <div className="col-5 text-right v-line">{t('auth.login.label2')}</div>
          <div className="col-5">
            <input
              type="text"
              className="form-control w-100"
              placeholder={t('student.student.placeholder5')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="col-2" />
        </div>
        <div className="row">
          <div className="col-5 text-right v-line">{t('student.student.column66')}</div>
          <div className="col-5">
            <input
              type="text"
              className="form-control w-100"
              placeholder={t('student.student.placeholder3')}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <div className="col-2" />
        </div>
      </Modal>
    </>
  );
};

export default ResetParentPasswordModal;
